<template>
  <div class="incidents-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $tc('entities.incident.incidentsManagement') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="incidentsShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'IncidentsHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            incidentsShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.incidentsTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.viewIncidentDetails'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.viewIncidentDetails')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.viewIncidentsAttachments'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'A' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.viewIncidentsAttachments')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
